import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { BarChart3, CalendarDays, HeartPulse, Check } from "lucide-react";
import { Reveal } from "./Reveal";
import { INSTRUMENTS, TIMELINE, PULSE } from "@/data/content";

export default function About() {
  return (
    <section id="hakkinda" className="bg-white pb-8 pt-4">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-3 gap-8 lg:gap-10 border-t border-slate-100 pt-12">
          {/* Borsa Nedir */}
          <Reveal>
            <div className="flex items-center gap-3 mb-5">
              <span className="grid place-items-center w-11 h-11 rounded-lg bg-brand text-white">
                <BarChart3 className="w-5 h-5" strokeWidth={2} />
              </span>
              <div>
                <h3 className="font-extrabold text-navy text-xl tracking-tight">BORSA NEDİR?</h3>
                <p className="text-brand font-semibold text-sm">Sermayenin Buluşma Noktası</p>
              </div>
            </div>
            <p className="text-slate-600 text-sm leading-relaxed">
              Borsa; şirketlerin büyüme amacıyla yatırımcılardan sermaye topladığı, yatırımcıların ise
              ortaklık payı satın alarak şirketlerin geleceğine yatırım yaptığı organize piyasalardır.
            </p>
            <p className="text-slate-700 text-sm mt-4 mb-3">
              Borsa İstanbul'da hisse senetlerinin yanı sıra;
            </p>
            <ul className="space-y-2.5">
              {INSTRUMENTS.map((it, i) => {
                const Icon = Icons[it.icon] || Icons.Check;
                return (
                  <motion.li
                    key={it.label}
                    initial={{ opacity: 0, x: -10 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.05, duration: 0.4 }}
                    className="flex items-center gap-3 text-slate-700 text-sm"
                  >
                    <Icon className="w-4 h-4 text-brand shrink-0" strokeWidth={2} />
                    {it.label}
                  </motion.li>
                );
              })}
            </ul>
            <p className="text-slate-500 text-sm mt-4">gibi birçok yatırım ürünü işlem görmektedir.</p>
          </Reveal>

          {/* Dünden Bugüne */}
          <Reveal delay={1}>
            <div className="flex items-center gap-3 mb-6">
              <span className="grid place-items-center w-11 h-11 rounded-lg bg-brand text-white">
                <CalendarDays className="w-5 h-5" strokeWidth={2} />
              </span>
              <div>
                <h3 className="font-extrabold text-navy text-xl tracking-tight">DÜNDEN BUGÜNE</h3>
                <p className="text-brand font-semibold text-sm">Türkiye Borsasının Yolculuğu</p>
              </div>
            </div>
            <ol className="relative border-l-2 border-brand/25 ml-1.5 space-y-5">
              {TIMELINE.map((t, i) => (
                <motion.li
                  key={t.year}
                  initial={{ opacity: 0, x: -10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.08, duration: 0.45 }}
                  className="pl-5"
                >
                  <span className="absolute -left-[7px] mt-1 w-3 h-3 rounded-full bg-brand ring-4 ring-white" />
                  <p className="font-extrabold text-brand text-base leading-none">{t.year}</p>
                  <p className="text-slate-600 text-sm mt-1.5 leading-relaxed">{t.text}</p>
                </motion.li>
              ))}
            </ol>
          </Reveal>

          {/* Türkiye Ekonomisinin Nabzı */}
          <Reveal delay={2}>
            <div className="flex items-center gap-3 mb-5">
              <span className="grid place-items-center w-11 h-11 rounded-lg bg-brand text-white">
                <HeartPulse className="w-5 h-5" strokeWidth={2} />
              </span>
              <div>
                <h3 className="font-extrabold text-navy text-xl tracking-tight">TÜRKİYE EKONOMİSİNİN NABZI</h3>
                <p className="text-brand font-semibold text-sm">Güncel Yapı</p>
              </div>
            </div>
            <ul className="space-y-3.5">
              {PULSE.map((p) => (
                <li key={p} className="flex items-start gap-3 text-slate-700 text-sm">
                  <span className="grid place-items-center w-5 h-5 rounded-full bg-green-100 text-green-600 shrink-0 mt-0.5">
                    <Check className="w-3 h-3" strokeWidth={3} />
                  </span>
                  <span className="leading-relaxed">{p}</span>
                </li>
              ))}
            </ul>
            <motion.img
              src="/turkey-map.png"
              alt="Türkiye haritası"
              initial={{ opacity: 0, scale: 0.94 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              className="mt-6 w-full max-w-[280px]"
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
